 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MarkTravel',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var date = new Date();

		$('#marktravel-cancellation_date').data('DateTimePicker').maxDate(date);
	};

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];
		}
	};
}(jQuery, window.Adzuki || {}));